define('views/components/credit_card/credit_card',['require','backbone','text!templates/components/credit_card/credit_card.html'],function (require) {
  var Backbone = require("backbone");

  var temp = require("text!templates/components/credit_card/credit_card.html");
  return Backbone.Marionette.ItemView.extend({
    tagName: "div",
    template: _.template(temp),
    className: "row m-b-10 credit-card-item",

    ui: function () {
      return {
        deleteButton: ".delete-credit-card",
        creditCard: '[name="credit_card_option"]',
      };
    },

    events: {
      "click @ui.deleteButton": "deleteButtonClicked",
    },

    onRender: function () {
      var paymentService = this.model.get("payment_service");
      this.ui.creditCard.prop(
        "disabled",
        App.context.hasBasketRecurringProduct && paymentService == 3
      );

    },

    deleteButtonClicked: function () {
      var _this = this;
      App.utils.showConfirmModal(
        App.polyglot.t("delete_credit_card_confirm_message"),
        function () {
          _this.model.destroy();
        }
      );
    },
  });
});

